import { Divider, Paper, Stack, Text } from '@mantine/core';
import { useQuery } from '@tanstack/react-query';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import { PendingSpinner } from '@/core/components';

import { getUserDocumentSlotsOptions } from '../model/UserDocumentQuery';
import { userDocumentKindList } from '../model/UserDocumentTypes';
import { UserDocumentSlotRow } from './UserDocumentSlotRow';

export function UserDocumentsCard() {
  const { t } = useTranslation();
  const { data, isPending, isError } = useQuery(getUserDocumentSlotsOptions());

  const uploadedCount = data?.filter(slot => slot.document != null).length ?? 0;

  return (
    <Paper
      flex={1}
      p="md"
      mih="200px"
    >
      <Stack gap="4px">
        <Text>{t('userDocuments.title')}</Text>
        {isPending && <PendingSpinner h="120px" />}
        {isError && data == null && (
          <Text
            c="dimmed"
            size="sm"
            fs="italic"
          >
            {t('userDocuments.loadError')}
          </Text>
        )}
        {data != null && (
          <>
            <Text
              c="dimmed"
              size="sm"
              fs="italic"
            >
              {t('userDocuments.completeness', { uploaded: uploadedCount, total: userDocumentKindList.length })}
            </Text>
            <Stack
              gap="sm"
              mt="md"
            >
              {data.map((slot, index) => (
                <Fragment key={slot.kind}>
                  {index > 0 && <Divider />}
                  <UserDocumentSlotRow slot={slot} />
                </Fragment>
              ))}
            </Stack>
          </>
        )}
      </Stack>
    </Paper>
  );
}
